jQuery(document).ready(function($){
	var clear = $('.clearCart');
	var conflict = $('#cart-conflict');

	$('#conflict-close').click(function(){
		$('#cart-conflict').hide();
	});

	clear.click(function(){
		if($(this).hasClass('redirect-only')){
			runRedirect();
		} else {
			getCartItems();
		}
	});

	function getCartItems(){
		var result = $.getJSON( '/cart.js', function( data ) {
			console.log(data.items);
			removeItems(data.items);
		});
	}
	
	function removeItems(items){
		var str = '';

		items.forEach(function(item){
			if(item.product_type == 'Clip-in Hair Extensions' || item.product_type == 'Try On' || item.product_type == 'Box'){
				var variant = item.variant_id;
				if(str.length){
					str += '&updates['+variant+']=0';
				} else {
					str += 'updates['+variant+']=0';
				}
			}
		});

		$.post('/cart/update.js', str);

		runRedirect();
	}

	function runRedirect(){
		var path = conflict.data('redirect');
		setTimeout(function(){
      window.location.href = path;
    }, 2000);
	}
});